// Grouping
export const REQUEST_ACCOUNTS = '@main/REQUEST_ACCOUNTS_GROUPING';
export const SET_GROUPING = '@main/SET_GROUPING';
export const FETCH_ACCOUNT_GROUPING = '@main/FETCH_ACCOUNT_GROUPING';
